export const warn = (what: string) => (error: unknown) =>
  console.warn(`${what} failed after commit`, error);
